<form [formGroup]="creditTiersForm">
  <select class="form-control" formControlName="creditTier" (change)="onSelectCreditTier()">
    <option value="" disabled>
      Select Credit Tier
    </option>
    <option *ngFor="let option of creditTiers; let i=index;" [value]="option.tier">
      {{ option.name }}
    </option>
  </select>
</form>